import styled from "styled-components";
import { DailySettlementContentWrapper } from "../../../style";

export const DailySettlementTournamentWrapper = styled(
  DailySettlementContentWrapper
)`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 25px 30px;
  overflow: scroll;
  scrollbar-width: none;
`;

export const DailySettlementTournamentItem = styled.div`
  background: #ecf0f3;
  padding: 30px 20px;
  box-sizing: border-box;
  border-radius: 20px;
  width: 100%;
`;

export const DailySettlementTournamentTitle = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  > .right {
    display: flex;
    gap: 12px;
    align-items: center;
  }

  .box {
    width: max-content;
    height: 26px;
    padding: 0 10px;
    border-radius: 15px;
    background: #969696;
    font-family: Pretendard;
    font-weight: 700;
    font-size: 14px;
    line-height: 26px;
    color: #fff;
  }

  .button {
    background: #373636;
    padding: 0 22.5px;
    cursor: pointer;
  }
`;

export const DailySettlementTournamentItemInfoWrapper = styled.div<{
  gap?: string;
}>`
  display: flex;
  gap: ${(p) => (p.gap ? p.gap : "18px")};
  margin: 20px 0;
`;

export const DailySettlementTournamentItemInfo = styled.div`
  height: 132px;
  border-radius: 12px;
  padding: 12px 8px;
  box-sizing: border-box;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  gap: 20px;

  > .name {
    width: max-content;
    height: 26px;
    padding: 0 22px;
    border-radius: 12px;
    background: #d9d9d9;
    font-family: Pretendard;
    font-weight: 700;
    font-size: 16px;
    line-height: 26px;
  }
`;

export const DailySettlementTournamentItemTable = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;

  .item {
    width: 95.3px;

    &.weight {
      width: 130px;
    }
  }
`;

export const DailySettlementTournamentItemTableHeader = styled.div`
  display: flex;
  border-bottom: 2px solid #373636;
  padding-bottom: 6px;

  > .item {
    font-family: Pretendard;
    font-weight: 500;
    font-size: 16px;
    text-align: center;
    color: #373636;
  }
`;

export const DailySettlementTournamentItemTableBody = styled.div`
  display: flex;
  height: 31px;

  > .item {
    font-family: Pretendard;
    font-weight: 700;
    font-size: 16px;
    text-align: center;
    color: #121212;
    line-height: 31px;

    > span {
      font-family: Pretendard;
      font-weight: 700;
      font-size: 12px;
      color: #969696;
    }
  }
`;

export const DailySettlementTournamentPopupWrapper = styled.div`
  padding: 40px 20px 30px;
  border-radius: 13px;
  background: #ffffff;
  position: absolute;
  z-index: 1000;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const DailySettlementTournamentPopupItemInfo = styled.div`
  border-radius: 12px;
  padding: 20px 15px;
  box-sizing: border-box;
  background: #f0f0f0;
  width: 302px;
`;

export const DailySettlementTournamentPopupItemTable = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 20px;
`;
